// Routes
export const INDEX = '/'
export const IMAGES = 'images'
export const GRID = 'grid'
export const INFO = 'info'
